export enum EHelpMessageRole {
  User = 'user',
  Assistant = 'assistant',
}
